import { BillStatuses } from "@legacy/core/utils/enums"

import { Table } from "@organisms"

import { BILLS_ROUTES } from "@routes/bills"

export const BillTableViewTabs = () => (
    <Table.Tabs>
        <Table.Tab
            id="all_open"
            phase="open"
            title="All Open"
            isDefaultActiveTabForPhase={true}
            endpointKwargs={[
                ["status", BillStatuses.pending],
                ["status", BillStatuses.unpaid],
                ["ordering", "date_due"],
            ]}
            listEndpoint={BILLS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={BILLS_ROUTES.COUNT}
        />
        <Table.Tab
            id="pending"
            phase="open"
            title="Pending"
            endpointKwargs={[
                ["status", BillStatuses.pending],
                ["ordering", "date_due"],
            ]}
            listEndpoint={BILLS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={BILLS_ROUTES.COUNT}
        />
        <Table.Tab
            id="outstanding"
            phase="open"
            title="Outstanding"
            endpointKwargs={[
                ["status", BillStatuses.unpaid],
                ["is_overdue", "false"],
                ["ordering", "date_due"],
            ]}
            listEndpoint={BILLS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={BILLS_ROUTES.COUNT}
        />
        <Table.Tab
            id="overdue"
            phase="open"
            title="Overdue"
            endpointKwargs={[
                ["status", BillStatuses.unpaid],
                ["is_overdue", "true"],
                ["ordering", "date_due"],
            ]}
            listEndpoint={BILLS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={BILLS_ROUTES.COUNT}
        />
        <Table.Tab
            id="all_closed"
            phase="closed"
            title="All Closed"
            isDefaultActiveTabForPhase={true}
            endpointKwargs={[
                ["status", BillStatuses.paid],
                ["status", BillStatuses.voided],
                ["ordering", "-date_due"],
            ]}
            listEndpoint={BILLS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={BILLS_ROUTES.COUNT}
        />
        <Table.Tab
            id="paid"
            phase="closed"
            title="Paid"
            endpointKwargs={[
                ["status", BillStatuses.paid],
                ["ordering", "-date_due"],
            ]}
            listEndpoint={BILLS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={BILLS_ROUTES.COUNT}
        />
        <Table.Tab
            id="voided"
            phase="closed"
            title="Voided"
            endpointKwargs={[
                ["status", BillStatuses.voided],
                ["ordering", "-date_due"],
            ]}
            listEndpoint={BILLS_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={BILLS_ROUTES.COUNT}
        />
    </Table.Tabs>
)
